<template>
  <div>
    <BaseTitle :title="$t('content.discussion')" :yearPeriode="titleData" />

    <v-card>
      <div>
        <div class="pa-5 d-flex justiy-space-between align-items section-header active">
          <div class="student-title">{{ $t('content.discussion') }}</div>
        </div>
        <div class="ml-5 mt-3 mr-5">
          <div class="d-flex align-center justify-space-between">
            <div>
              <v-btn
                color="primary"
                class="btn-primary-custom mb-2 mb-md-0 mr-md-2"
                @click="addDiscussion()"
                v-if="
                  (isStudent === false && permissionButton('ROLE_DISCUSSION_CREATE')) ||
                    (isStudent === false && permissionButton('ROLE_DISCUSSION_LITE_CREATE'))
                "
                >{{ $t('add') }}</v-btn
              >
            </div>
            <v-progress-circular class="text-center" v-if="loadingLoad === true" indeterminate color="primary"></v-progress-circular>
            <div>
              <v-text-field v-model="search" :label="$t('search')" @input="getData">
                <template #prepend-inner>
                  <svg-icon icon="ic-search" class="primary--text mr-3" />
                </template>
              </v-text-field>
            </div>
          </div>
        </div>
        <div v-for="item in datas" :key="item.discussionId">
          <div
            class="border-item"
            v-if="(!isStudent && item.hide === false) || (!isStudent && item.hide === true) || (isStudent && item.hide === false)"
          >
            <v-row v-if="item.inDate === true && lengthDatas > 0">
              <v-col md="1" align="center">
                <div class="mt-2 ml-5">
                  <img v-if="item.imageUrl" :src="item.imageUrl" class="user-photo" />
                  <img v-else :src="require('@/assets/images/sample-user.png')" class="user-photo" />
                  <v-divider vertical></v-divider>
                </div>
              </v-col>
              <v-col md="10" class="mt-3">
                <div class="d-block">
                  <h3 class="d-inline">
                    <span class="header-content">{{ item.subject }} </span>
                  </h3>
                </div>
                <div class="d-block">
                  <v-row>
                    <v-col md="9">
                      <span class="body-content">
                        <span class="mr-3">
                          {{ $t('table.date') }} :
                          <strong>{{ item.datetime }}</strong>
                        </span>
                        |
                        <span class="mr-3">
                          {{ $t('content.by') }} :
                          <strong>{{ item.by }}</strong>
                        </span>

                        <span class="mr-3" v-if="isStudent === false">
                          |

                          {{ $t('form.status') }}:
                          <strong v-if="item.hide === false" class="green--text font-italic header-content">{{ $t('paginate.show') }}</strong>
                          <strong v-else class="red--text font-italic header-content">{{ $t('content.hide') }}</strong>
                        </span>
                      </span>
                    </v-col>
                    <v-col md="3">
                      <svg-icon icon="comment" width="20" class="primary--text mr-3" />
                      <span class="body-content-blue"> {{ item.totalComment }} {{ $t('content.comment') }} </span></v-col
                    >
                  </v-row>
                  <div></div>
                </div>
                <div class="d-flex"></div>
              </v-col>
              <v-col md="1" class="mt-5">
                <template>
                  <div class="pa-5">
                    <v-menu offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <span dark v-bind="attrs" v-on="on">
                          <svg-icon icon="ic-moreaction-black" class="mt-1" />
                        </span>
                      </template>
                      <v-list>
                        <v-list-item v-if="permissionButton('ROLE_DISCUSSION_VIEW') || permissionButton('ROLE_DISCUSSION_LITE_VIEW')">
                          <v-list-item-title class="text-dropdown" @click="goView(item)">{{ $t('view') }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-if="
                            (isStudent === false && permissionButton('ROLE_DISCUSSION_UPDATE')) ||
                              (isStudent === false && permissionButton('ROLE_DISCUSSION_LITE_UPDATE'))
                          "
                        >
                          <v-list-item-title class="text-dropdown" @click="goEdit(item.discussionId)">{{ $t('edit') }}</v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          v-if="
                            (isStudent === false && item.totalComment === 0 && permissionButton('ROLE_DISCUSSION_DELETE')) ||
                              (isStudent === false && item.totalComment === 0 && permissionButton('ROLE_DISCUSSION_LITE_DELETE'))
                          "
                        >
                          <v-list-item-title class="text-dropdown-delete" @click="goDelete(item)">{{ $t('table.delete') }}</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </template>
              </v-col>
            </v-row>
          </div>
        </div>
        <NoData v-if="!lengthDatas" />
      </div>
    </v-card>
    <!-- Dialog Delete -->
    <v-dialog v-model="dialogDelete" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">{{ $t('delete_title') }}</v-card-title>
        <v-card-text>{{ $t('delete_message') }}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogDelete = false">{{ $t('disagree') }}</v-btn>
          <v-btn text @click="deleteDetail">{{ $t('aggree') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';
import NoData from '@/components/table/NoData';
import moment from 'moment-timezone';

export default {
  name: 'DisscusionIndex',
  components: {
    BaseTitle,
    NoData
  },
  props: {
    isClass: {
      type: Boolean,
      default: false
    },
    isStudent: {
      type: Boolean,
      default: false
    }
  },
  sockets: {
    connect() {
      console.log('socket connected');
    },
    discussion({ classId, courseId }) {
      const { classId: currentClassId, courseId: currentCourseId } = this.$route.params;
      if (classId == currentClassId && courseId == currentCourseId) {
        this.$store.dispatch('general/showSuccessNotification', { message: 'Update List Discussion' });
        setTimeout(() => {
          this.getData();
        }, 400);
      }
    }
  },
  computed: {
    ...mapGetters({
      course: 'QuizTeacher/courses',
      classLevel: 'QuizTeacher/classLevel',
      permission: 'Auth/permission',
      user: 'Auth/user',
      nameCourse: 'CourseList/nameCourse'
    })
  },
  data: () => ({
    loadingButton: false,
    dialogDelete: false,
    loadingLoad: false,
    dataClass: '',
    datas: '',
    search: '',
    currentItem: '',
    gmt: '',
    lengthDatas: 0,
    titleData: ''
  }),
  methods: {
    getProfile() {
      this.$store.dispatch('User/fetchProfile').then(res => {
        if (res.gmt === null) {
          this.gmt = 'Asia/Jakarta';
        } else {
          this.gmt = res.gmt;
        }
      });
    },
    permissionButton(push) {
      return this.permission.some(p => p === push) ?? false;
    },
    getDataClass() {
      if (!this.$route.params.classSectionId) {
        this.$store
          .dispatch('Class/fetchClassroomCourseName', { classId: this.$route.params.classId, courseId: this.$route.params.courseId })
          .then(res => {
            if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
              this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            } else {
              this.$store.dispatch('Class/fetchListLiteDetail', this.$route.params.classId).then(resa => {
                this.dataClass = resa;
                this.titleData = res + ` ( ${resa.yearPeriode} ) `;
              });
            }
          });
      } else {
        this.$store.dispatch('ClassSection/getListDetail', { classSectionId: this.$route.params.classSectionId }).then(res => {
          if (this.user.cerdasTypeId === 2 || this.user.cerdasTypeId === null) {
            this.$store.dispatch('SchoolClass/fetchDetail', this.$route.params.classId).then(resa => {
              this.dataClass = resa;
              this.titleData = res.classroomName + ` ${res.numberClass}` + ` ( ${resa.yearPeriode} ) `;
            });
          }
        });
      }
    },
    getData() {
      this.loadingLoad = true;
      this.$store
        .dispatch('Discussion/getDataAll', {
          classroomId: this.$route.params.classId,
          courseId: this.$route.params.courseId,
          classSectionId: this.$route.params.classSectionId ? this.$route.params.classSectionId : '',
          search: this.search
        })
        .then(res => {
          if (res) {
            res.forEach(datas => {
              if (datas.availableFrom && this.isStudent === true) {
                var future = moment(datas.availableFrom, 'DD/MM/YYYY HH:mm').format('YYYY-MM-DD HH:mm');
                if (this.gmt) {
                  var convertAwal = moment()
                    .tz(this.gmt)
                    .format('YYYY-MM-DD HH:mm');
                } else {
                  convertAwal = moment().format('YYYY-MM-DD HH:mm');
                }
                var convertAkhir = moment(future).format('YYYY-MM-DD HH:mm');
                if (convertAwal >= convertAkhir) {
                  datas.inDate = true;
                } else {
                  datas.inDate = false;
                }
              } else {
                datas.inDate = true;
              }
            });
            this.datas = res;
            this.lengthDatas = res.filter(x => {
              return x.inDate;
            }).length;
          }
        })
        .finally(() => {
          this.loadingLoad = false;
        });
    },
    addDiscussion() {
      if (!this.$route.params.classSectionId) {
        this.$router.push({ name: 'DiscussionCreateClass' });
      } else {
        this.$router.push({ name: 'DiscussionSectionCreateClass' });
      }
    },
    getCourse() {
      this.$store.dispatch('QuizTeacher/fetchClassLevelOrCourse', this.form.gradeId);
    },
    goView(item) {
      if (item.availableFrom && this.isStudent) {
        var future = moment(item.availableFrom, 'DD/MM/YYYY HH:mm').format('YYYY-MM-DD HH:mm');
        if (this.gmt) {
          var convertAwal = moment()
            .tz(this.gmt)
            .format('YYYY-MM-DD HH:mm');
        } else {
          convertAwal = moment().format('YYYY-MM-DD HH:mm');
        }
        var convertAkhir = moment(future).format('YYYY-MM-DD HH:mm');
        if (convertAwal >= convertAkhir) {
          localStorage.setItem('detailStudent', true);
          if (!this.$route.params.classSectionId) {
            this.$router.push({ name: 'DiscussionStudentViewClass', params: { id: item.discussionId } });
          } else {
            this.$router.push({ name: 'DiscussionStudentSectionViewClass', params: { id: item.discussionId } });
          }
        } else {
          this.$store.dispatch('general/showErrorNotification', { message: 'Discussion Not Ready' });
          localStorage.setItem('detailStudent', false);
        }
      } else {
        localStorage.setItem('detailStudent', true);
        if (this.isStudent) {
          if (!this.$route.params.classSectionId) {
            this.$router.push({ name: 'DiscussionStudentViewClass', params: { id: item.discussionId } });
          } else {
            this.$router.push({ name: 'DiscussionStudentSectionViewClass', params: { id: item.discussionId } });
          }
        } else {
          if (!this.$route.params.classSectionId) {
            this.$router.push({ name: 'DiscussionViewClass', params: { id: item.discussionId } });
          } else {
            this.$router.push({ name: 'DiscussionSectionViewClass', params: { id: item.discussionId } });
          }
        }
      }

      // if (this.isClass && !this.isStudent) {
      //   this.$router.push({ name: 'DiscussionViewClass', params: { id: item.discussionId } });
      // } else if (this.isClass && this.isStudent) {
      //   this.$router.push({ name: 'DiscussionStudentViewClass', params: { id: item.discussionId } });
      // } else {
      //   this.$router.push({ name: 'DiscussionView', params: { id: item.discussionId } });
      // }
    },
    goEdit(id) {
      if (!this.$route.params.classSectionId) {
        this.$router.push({ name: 'DiscussionEditClass', params: { id } });
      } else {
        this.$router.push({ name: 'DiscussionSectionEditClass', params: { id } });
      }
    },
    goDelete(item) {
      this.dialogDelete = true;
      this.currentItem = item.discussionId;
    },
    deleteDetail() {
      if (!this.currentItem) return false;

      this.loadingButton = true;
      this.$store
        .dispatch('Discussion/destroy', this.currentItem)
        .then(({ data }) => {
          this.$store.dispatch('general/showSuccessNotification', data);
          this.currentItem = null;
          this.getData();
          this.dialogDelete = false;
        })
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e))
        .finally(() => (this.loadingButton = false));
    }
  },
  created() {
    this.getData();
    this.getProfile();
    if (this.isClass) {
      this.getDataClass();
    } else {
      localStorage.removeItem('courseName');
    }
  }
};
</script>

<style lang="scss" scoped>
.assignment {
  &-title {
    font-family: Montserrat;
    font-weight: bold;
    color: #6d6d6d;
    font-size: 18px;
  }

  &-head {
    font-family: Montserrat;
    font-weight: bold;
    color: #6d6d6d;
    font-size: 16px;
  }

  &-content {
    margin: 10px 20px 20px 20px;

    font-family: Montserrat;
    line-height: 16px;
    font-size: 12px;
  }
}
.section-header {
  border-radius: 4px 4px 0 0;

  &.active {
    background: #00bf63;
    .student-title {
      color: #fff;
      font-size: 18px;
      font-weight: bold;
    }
  }

  &.disabled {
    background: #acacac;
    pointer-events: none;

    .student-title {
      color: #fff;
    }
  }
}
.section-footer {
  border-radius: 4px 4px 0 0;
  background: #e7f5ff;
}
.header-circle {
  background-color: #00bf63;
  border: 1px solid #ffffff;
  border-radius: 8px;
  width: 110px;
  height: 23px;
}
.header-circle-text {
  color: #ffffff;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  margin-left: 10px;
}
.assignment-item {
  display: flex;
  flex-direction: column;
  padding: 20px 0;
  border-bottom: 1px solid #dedede;
  // &:last-child {
  //   border-bottom: 0;
  //   // border-bottom: 1px solid #dedede;
  // }

  &-icon {
    width: 24px;
    height: 24px;
    border-radius: 8px;
    background: #fff0da;
    color: #f1b65a;
    text-align: center;
    line-height: 24px;
    margin-right: 12px;

    svg {
      margin-top: 3px;
    }
  }

  &-section {
    margin-bottom: 15px;

    &:last-child {
      margin-bottom: 0;
    }

    &-title {
      display: block;
    }

    strong {
      color: #6d6d6d;
    }
  }

  @include query-min-sm() {
    flex-direction: row;
    align-items: center;

    &-section {
      flex-basis: 25%;
      margin-bottom: 0;
    }
  }
}
.text-dropdown {
  cursor: pointer;
  &-delete {
    color: red;
    cursor: pointer;
  }
  &-grey {
    color: grey;
    cursor: pointer;
  }
}

.attendance-scroller {
  overflow-x: scroll;
  overflow-y: visible;
}

.attendance-table {
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;

  th {
    padding: 10px;
    text-align: left;
    color: #fff;
  }

  td {
    padding: 0px 13px;
    height: 50px;
    border-right: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    background: #fff;

    &:not(.attendance-sticky) {
      font-weight: bold;
      cursor: pointer;

      &:hover {
        background: #f8f8f8;
      }
    }
  }

  thead {
    tr {
      th {
        $height: 100px;
        height: $height;
        background: #00bf63;

        div {
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          position: relative;

          button {
            position: absolute;
            top: -5px;
            right: 0;
          }
        }
      }
    }
  }
}

.user {
  &-photo {
    width: 48px;
    height: 48px;
    overflow: hidden;
    border-radius: 100px;
    margin-right: 10px;
  }
}

.assigment-icon {
  width: 30px;
  height: 30px;
}

.border-item {
  border-bottom: 1px solid #dedede;
}
.text-dropdown {
  cursor: pointer;
  &-delete {
    color: red;
    cursor: pointer;
  }
}

.header-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 14px;
  line-height: 16px;
  width: 133px;
  text-align: left;
}

.body-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}
.body-content-blue {
  color: #00bf63;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}

.section-header {
  border-radius: 4px 4px 0 0;

  &.active {
    background: #00bf63;
    .student-title {
      color: #fff;
      font-size: 18px;
      font-weight: bold;
    }
  }

  &.disabled {
    background: #acacac;
    pointer-events: none;

    .student-title {
      color: #fff;
    }
  }
}
</style>
